// services/authService.js

import { post } from './api_service';
import { userservice } from './userService'; // endpoint paths mapped here

// 1. Sign In 
export const signInAPI = async (email, token) => {
    return await post(userservice.userRegistration, {
        email,
        token,
        device_id: '23456',
    });
};

// 2. Verify OTP
export const verifyOtpAPI = async (email, otp, token) => {
    return await post(userservice.otpverify, {
        email,
        emailotp: otp,
    }, token);
};

// 3. Create Password
export const createPasswordAPI = async (user_id, name, password) => {
    return await post(userservice.createPassword, {
        user_id,
        name,
        password,
    });
};

// 4. Login
export const loginAPI = async (email, password, token) => {
    return await post(userservice.userLogin, {
        email,
        password,
        token,
        device_id: 'di',
    }, token);
};

// 5. Forget Password
export const forgetPasswordAPI = async (email, token) => {
    return await post(userservice.forgetPassword, { email }, token);
};

// 6. Verify OTP for Password Reset
export const verifyOtpForPasswordResetAPI = async (email, otp, token) => {
    return await post(userservice.verifyOtpForPasswordReset, {
        email,
        emailotp: otp,
    }, token);
};

// 7. Get Expert Approval Status
export const getExpertApprovalStatusAPI = async (expert_id, token) => {
    return await post(userservice.getExpertById, { expert_id }, token);
};


export const getAdminSessionPriceAPI = async () => {
    return await post(userservice.getAdminSessionPrice);
  };
